// extracted by mini-css-extract-plugin
export default {"container":"ModeSwitchBtn_container__uIedO","button":"ModeSwitchBtn_button__k2Sag","icon":"ModeSwitchBtn_icon__nUzbZ"};